import { useParams } from "react-router-dom";
import { DocumentsProvider } from "@my-helpers/common";
import Layout from "../layout";
import DocumentView from "./document";
import DocumentsView from "./documents";

const Documents = () => {
    const { id } = useParams<{ id: string }>();
	return (
		<Layout>
			<DocumentsProvider documentId={id}>
                {
                    id ? <DocumentView documentId={id} /> :
                    <DocumentsView />
                }
			</DocumentsProvider>
		</Layout>
	);
};

export default Documents;